import React from 'react';
import { FieldErrors } from './FieldErrors';
export const NumberInput = (props) => {
    const onChange = (event) => {
        props.onChange(parseInt(event.currentTarget.value, 10));
    };
    return (React.createElement("div", { className: "input-set" },
        React.createElement("label", { htmlFor: props.id },
            props.label,
            " ",
            props.required ? '*' : ''),
        React.createElement("input", { type: "number", id: props.id, value: props.value || '', onChange: onChange }),
        React.createElement(FieldErrors, { errors: props.errors, name: props.name || props.id })));
};
